import axios from "axios";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import './input.css';
import Data, {DataAPi} from "./variable/dataVariable.js"

export default function Input() {
    const [values, setValues] = useState({
        namaBarang: '',
        merek: '',
        type: '',
        warna: '',
        bahan: '',
        kategori: '',
        kategoriCode: '',
        tanggalBeli: '',
        kondisi: '',
        jumlahBarang: '',
        hargaSatuan: '',
        tahunAnggaran: '',
        spesifikasi: '',
        jenisAset: '',
        gedung: '',
        gedungCode: '',
        ruangan: '',
        ruanganCode: '',
        isiSilinder: '',
        nomorRangka: '',
        nomorMesin: '',
        nomorBPKB: '',
        bahanBakar: '',
        image: 'https://fakeimg.pl/300x300/',
    })

    const [setRuang, saveSetRuang] = useState("0");
    const [saveImage, setSaveImage] = useState(null);

    const uploadChange = (e) => {
        console.log(e.target.files[0]);
        const uploaded = e.target.files[0];
        setSaveImage(uploaded);
        setValues({image: URL.createObjectURL(uploaded)})
        console.log(values.image);
        document.getElementById("setShow").style.display = "none"
        document.getElementById("Checked").checked = false
        document.getElementById("btnUpload").style.display = "inline-block"
    }

    let formData = new FormData();
    formData.append("image", saveImage);

    const navigate = useNavigate();
    
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(values);
        axios.post(DataAPi.urlPostCreate, values)
        .then(res => {
            navigate("/inventaris", {replace: true})
            console.log(res)
        })
        .catch(err => console.log(err))
    }

    const uploadImage = () => {
        if(!saveImage){
            alert("Lakukan upload gambar dulu")
        }else{
            fetch(DataAPi.urlPostImage, {
                method: "POST",
                body: formData            })
            .then((res) => res.json()).then(data => {
                if(data.status === 'success') {
                    setValues({image: data.image})
                    console.log(data);
                    
                    document.getElementById("setShow").style.display = "block"
                    document.getElementById("Checked").checked = false
                    document.getElementById("btnUpload").style.display = "none"
                }
            })
        }
    }

    return (
        <div className="container-sm py-5">
            <div className="text-center pb-4">
                <h2>Tambah Aset Baru</h2>
            </div>
            <div className="row g-3 p-5 bg-light shadow input-group-lg fw-semibold rounded">
            <label className="form-label fs-4 border-bottom border-2 border-success" for="InputBahanBakar">Upload Gambar</label>
                    <div className="col-md-12 text-center">
                        <img src={values.image} className="img-thumbnail"></img>
                        <input className="form-control mb-4 shadow-sm" type="text" name="InputUrlImage" style={{display: "none"}} onChange={e => setValues({...values, image: e.target.value})}></input>
                        <input className="form-control mb-4 shadow-sm" type="file" name="image" size="lg" accept="image/*" onChange={uploadChange}></input>
                        <button className="btn btn-primary" id="btnUpload" onClick={uploadImage}>Upload Gambar</button>
                        
                    </div>
            <form onSubmit={handleSubmit} id="formSumbit" className="col-md-12 row g-3 ">
                <div className="col-md-12 border-bottom border-2 border-success">
                    <h4>Deskripsi Aset</h4>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputNamaBarang">Nama Barang</label>
                    <input className="form-control mb-4 shadow-sm" type="text" name="InputNamaBarang" required onChange={e => setValues({...values, namaBarang: e.target.value})}></input>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputMerek">Merek</label>
                    <input className="form-control mb-4 shadow-sm" type="text" name="InputMerek" required onChange={e => setValues({...values, merek: e.target.value})}></input>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputType">Type</label>
                    <input className="form-control mb-4 shadow-sm" type="text" name="InputType" required onChange={e => setValues({...values, type: e.target.value})}></input>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputWarna">Warna</label>
                    <input className="form-control mb-4 shadow-sm" type="text" name="InputWarna" required onChange={e => setValues({...values, warna: e.target.value})}></input>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputBahan">Bahan</label>
                    <input className="form-control mb-4 shadow-sm" type="text" name="InputWarna" required onChange={e => setValues({...values, bahan: e.target.value})}></input>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputGedung">kategori</label>
                    <select className="form-control mb-4 shadow-sm" required onChange={e => setValues({...values, kategori: Data.Kategori[e.target.value].data, kategoriCode: Data.Kategori[e.target.value].dataCode})}>
                        <option selected>Pilih Kategori</option>
                        {
                            Data.Kategori.map((kategori, index) => {
                                return (
                                    <option value={`${index}`}>{kategori.data}</option>
                                )
                            })
                        }
                    </select>
                </div>
                <div className="col-md-2">
                    <label className="form-label fs-6" for="InputTanggalPembelian">Tanggal Pembelian</label>
                    <input className="form-control mb-4 shadow-sm" type="date" name="InputTanggalPembelian" required onChange={e => setValues({...values, tanggalBeli: e.target.value})}></input>
                </div>
                
                <div className="col-md-2">
                    <label className="form-label fs-6" for="InputKondisiBarang">Kondisi Barang</label>
                    <select className="form-control mb-4 shadow-sm" required onChange={e => setValues({...values, kondisi: e.target.value})}>
                        <option selected>Kondisi</option>
                        <option value="Baru">Baru</option>
                        <option value="Bekas">Bekas</option>
                    </select>
                </div>

                <div className="col-md-2">
                    <label className="form-label fs-6" for="InputJumlahBarang">Jumlah Barang</label>
                    <div className="input-group flex-nowrap">
                        <input className="form-control mb-4 shadow-sm" aria-describedby="basic-addon1" type="number" min="1" name="InputJumlahBarang" required onChange={e => setValues({...values, jumlahBarang: e.target.value})}></input>
                        <span className="input-group-text mb-4" id="basic-addon1">Unit</span>
                    </div>
                    
                </div>

                <div className="col-md-3">
                    <label className="form-label fs-6" for="InputHargaSatuan">Harga Satuan</label>
                    <div className="input-group flex-nowrap">
                        <span class="input-group-text mb-4" id="basic-addon2">Rp</span>
                        <input className="form-control mb-4 shadow-sm" aria-describedby="basic-addon2" type="number" min="0" placeholder="5000000" name="InputHargaSatuan" required onChange={e => setValues({...values, hargaSatuan: e.target.value})}></input>
                    </div>
                </div>

                <div className="col-md-3">
                    <label className="form-label fs-6" for="InputTahunAnggaran">Tahun Anggaran</label>
                    <input className="form-control mb-4 shadow-sm" type="number" min="0" name="InputTahunAnggaran" required onChange={e => setValues({...values, tahunAnggaran: e.target.value})}></input>
                </div>

                <div className="col-md-10">
                    <label className="form-label fs-6" for="InputSpesifikasi">Spesifikasi</label>
                    <textarea className="form-control mb-4 shadow-sm" type="paragraph" name="InputSpesifikasi" rows="4" required onChange={e => setValues({...values, spesifikasi: e.target.value})}></textarea>
                </div>
                
                <div className="col-md-2">
                    <label className="form-label fs-6" for="InputKondisiBarang">Asal Aset</label>
                    <select className="form-control mb-4 shadow-sm" required onChange={e => setValues({...values, jenisAset: e.target.value})}>
                        <option selected>Asal Aset</option>
                        <option value="Pembelian">Pembelian</option>
                        <option value="Bantuan">Hibah</option>
                    </select>
                </div>
                <div className="col-md-12 border-bottom border-2 border-success">
                    <h4>Lokasi Aset</h4>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputGedung">Gedung</label>
                    <select className="form-control mb-4 shadow-sm" required onChange={e => {setValues({...values, gedung: Data.Gedung[e.target.value].data, gedungCode: Data.Gedung[e.target.value].dataCode}); saveSetRuang(e.target.value)}}>
                        <option selected>Pilih Lokasi</option>
                        {
                            Data.Gedung.map((gedung, index) => {
                                return (
                                    <option value={`${index}`}>{gedung.data}</option>
                                )
                            })
                        }
                    </select>
                </div>
                <div className="col-md-6">
                    <label className="form-label fs-6" for="InputRuangan">Ruangan</label>
                    <select className="form-control mb-4 shadow-sm" required onChange={e => setValues({...values, ruangan: Data.Ruangan[setRuang][e.target.value].data, ruanganCode: Data.Ruangan[setRuang][e.target.value].dataCode})}>
                        <option selected>Pilih Ruangan</option>
                        {
                            Data.Ruangan[setRuang].map((ruangan, index) => {
                                
                                return (
                                    <option value={`${index}`}>{ruangan.data}</option>
                                )
                            })
                        }
                    </select>
                </div>
                <div className="col-md-12 border-bottom border-2 border-success">
                    <h4>Jenis Aset</h4>
                </div>
                <div className="col-md-12">
                    <input className="form-check-input m-2" type="checkbox" id="a" style={{width: "20px", height: "20px"}} />
                        <label htmlFor="a" className="a m-2" for="a">
                            Centang Jika Aset Merupakan Kendaraan Bermotor
                        </label>
                    <div className="showUp">
                        <div className="col-md-6">
                            <label className="form-label fs-6" for="InputIsiSilinder">Isi Silinder</label>
                            <input className="form-control mb-4 shadow-sm" type="number" placeholder="1500 cc" name="InputIsiSilinder" onChange={e => setValues({...values, isiSilinder: e.target.value})}></input>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fs-6" for="InputNomorRangka">Nomor Rangka</label>
                            <input className="form-control mb-4 shadow-sm" type="text" name="InputNomorRangka" onChange={e => setValues({...values, nomorRangka: e.target.value})}></input>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fs-6" for="InputNomorMesin">Nomor Mesin</label>
                            <input className="form-control mb-4 shadow-sm" type="text" name="InputNomorMesin" onChange={e => setValues({...values, nomorMesin: e.target.value})}></input>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fs-6" for="InputNomorBPKB">Nomor BPKB</label>
                            <input className="form-control mb-4 shadow-sm" type="text" name="InputNomorBPKB" onChange={e => setValues({...values, nomorBPKB: e.target.value})}></input>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fs-6" for="InputBahanBakar">Bahan Bakar</label>
                            <input className="form-control mb-4 shadow-sm" type="text" name="InputBahanBakar" onChange={e => setValues({...values, bahanBakar: e.target.value})}></input>
                        </div>
                        </div>
                    </div>
                    
                    <div className="col-md-6" id="setShow" style={{display: "none"}}>
                    <input className="form-check-input m-2" type="checkbox" id="Checked" style={{width: "20px", height: "20px"}} required/>
                        <label htmlFor="a" className="a m-2" for="a">
                            Centang jika sudah mengisi semua data dan upload photo
                        </label>
                    </div>
                <div className="col-md-6 row g-2">
                    <button type="Submit" className="btn btn-success">Sumbit</button>
                    <Link to="/inventaris" className="btn btn-secondary">Kembali</Link>
                </div>

            </form>
            </div>
        </div>
    );
}
